import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7991ebac")

_pushScopeId("data-v-7991ebac")
const _hoisted_1 = { class: "form-content" }
const _hoisted_2 = { class: "margin-bottom10px" }
const _hoisted_3 = { class: "city-postal-item" }
const _hoisted_4 = { class: "margin-bottom10px" }
const _hoisted_5 = { class: "margin-bottom10px" }
const _hoisted_6 = {
  key: 0,
  style: {"color":"red"}
}
const _hoisted_7 = { style: {"color":"#F56C6C","font-size":"12px"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_cus_option = _resolveComponent("cus-option")
  const _component_cus_select = _resolveComponent("cus-select")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_form = _resolveComponent("el-form")
  const _component_cus_button = _resolveComponent("cus-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      model: _ctx.formData,
      class: "width500px",
      rules: _ctx.rules,
      "label-position": _ctx.$formLabelPosition
    }, {
      default: _withId(() => [
        _createVNode(_component_el_form_item, {
          label: _ctx.ChangeWordList.PMBasicSettingProjectName
        }, {
          default: _withId(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.formData.Location,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.Location = $event)),
              "auto-complete": "off"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.projectType === 'community' ? _ctx.$wordList.CommunityAddress : _ctx.$wordList.OfficeAddress
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.Street,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.Street = $event)),
                "auto-complete": "off",
                placeholder: _ctx.$wordList.TabelCommunitiesStreet
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_el_form_item, { class: "width50per" }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.City,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.City = $event)),
                    "auto-complete": "off",
                    placeholder: _ctx.$wordList.TabelCommunitiesCity
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                class: "width48per",
                prop: "PostalCode"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.PostalCode,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.PostalCode = $event)),
                    "auto-complete": "off",
                    placeholder: _ctx.$wordList.TabelCommunitiesPostal
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.States,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.States = $event)),
                "auto-complete": "off",
                placeholder: _ctx.$wordList.TabelCommunitiesState
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_cus_select, {
                modelValue: _ctx.formData.Country,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formData.Country = $event)),
                filterable: "",
                filter: ""
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.countryOption, (item) => {
                    return (_openBlock(), _createBlock(_component_cus_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.ChangeWordList.PMCreatePin
        }, {
          default: _withId(() => [
            (_ctx.isShowExpireTip)
              ? (_openBlock(), _createBlock("p", _hoisted_6, _toDisplayString(_ctx.$wordList.ProperAllTextFeatureExpireTips), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_el_radio_group, {
              modelValue: _ctx.formData.EnableUserPin,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formData.EnableUserPin = $event)),
              onChange: _ctx.changeUserPin
            }, {
              default: _withId(() => [
                _createVNode(_component_el_radio, { label: "1" }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOn), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_radio, { label: "0" }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOff), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue", "onChange"])
          ]),
          _: 1
        }, 8, ["label"]),
        (_ctx.projectType==='community')
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: _ctx.$wordList.TabelCommunitiesPinType
            }, {
              default: _withId(() => [
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.formData.AptPinType,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formData.AptPinType = $event)),
                  label: "0"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextPIN), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.formData.AptPinType,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formData.AptPinType = $event)),
                  label: "1"
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextAptKey), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_form_item, {
          label: _ctx.$wordList.ProperAllTextEmailDisconnected
        }, {
          default: _withId(() => [
            _createVNode(_component_el_radio, {
              modelValue: _ctx.formData.DevOfflineNotify,
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.formData.DevOfflineNotify = $event)),
              label: 1
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOn), 1)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_radio, {
              modelValue: _ctx.formData.DevOfflineNotify,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.formData.DevOfflineNotify = $event)),
              label: 0
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOff), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _ctx.$wordList.ProperAllTextSIMDataLimit
        }, {
          default: _withId(() => [
            _createVNode(_component_el_radio, {
              modelValue: _ctx.formData.EnableSIMWarning,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.formData.EnableSIMWarning = $event)),
              label: 1
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOn), 1)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_radio, {
              modelValue: _ctx.formData.EnableSIMWarning,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.formData.EnableSIMWarning = $event)),
              label: 0
            }, {
              default: _withId(() => [
                _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOff), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        (_ctx.formData.EnableSIMWarning==1)
          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_el_form_item, {
                label: _ctx.$wordList.ProperAllTextCountryRegion,
                prop: "PhoneCode"
              }, {
                default: _withId(() => [
                  _createVNode(_component_cus_select, {
                    modelValue: _ctx.formData.PhoneCode,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.formData.PhoneCode = $event)),
                    filter: "",
                    disabled: _ctx.isCNServer ? true : false,
                    "no-match-text": _ctx.$wordList.SelectNoData
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.phoneCode, (item) => {
                        return (_openBlock(), _createBlock(_component_cus_option, {
                          label: item.area + '(+' + item.code + ')',
                          value: item.code,
                          key: item.code
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled", "no-match-text"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _ctx.$wordList.ProperAllTextMobileNumber,
                prop: "MobileNumber"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.MobileNumber,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.formData.MobileNumber = $event)),
                    "auto-complete": "off",
                    onInput: _ctx.limitMobileNumberType
                  }, null, 8, ["modelValue", "onInput"])
                ]),
                _: 1
              }, 8, ["label"])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.community.ProjectType.value==='community'&&_ctx.community.isNew.value)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 2,
              class: "width800px;"
            }, {
              label: _withId(() => [
                _createVNode("div", null, _toDisplayString(_ctx.$wordList.UnlockAllTriggered), 1)
              ]),
              default: _withId(() => [
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.formData.TriggerAction,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.formData.TriggerAction = $event)),
                  label: 1
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOn), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_radio, {
                  modelValue: _ctx.formData.TriggerAction,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.formData.TriggerAction = $event)),
                  label: 0
                }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.$wordList.ProperAllTextOff), 1)
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode("div", _hoisted_7, _toDisplayString(_ctx.$wordList.LinkDeviceTypeTip), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model", "rules", "label-position"]),
    _createVNode(_component_cus_button, {
      type: "blue",
      onClick: _ctx.submit
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(_ctx.$wordList.TabelFootSubmit), 1)
      ]),
      _: 1
    }, 8, ["onClick"])
  ]))
})